
(function () {
  var SELECTOR = '[data-bg-reveal]';

  function revealAll() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-revealed');
  }

  function start() {
    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    try {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );

      var els = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < els.length; i++) observer.observe(els[i]);
    } catch (e) {
      revealAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
